import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';

class Collaborations extends React.Component {
  render(){
    return <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
      Scientific Collaborations
    </Header>
    <Divider/>

    <p>To establish deep understanding of the science and innovations by the portfolio
      companies, OVC will consult Triple Ring Technologies (TRT), a contract research
      enterprise based in Silicon Valley (Newark, California). Founded in 2005, the team
      is made up of over 100 scientists. Their business motto is to transform customer
      vision into proven technologies and products. The company operates laboratories
      for electronics, optics, radiation source development, mechanical prototyping,
      systems integration, and client incubation services.

      TRT also offers incubation space for select startups and introductions to capital
      sources.
    </p>
    </Container>;
  }
}

export default Collaborations;
